import { lazy } from 'react'
import { resolveThemedComponent } from '@/shared/theme'

type SourceLoader = () => Promise<unknown>

function themedLazy(sourceImport: SourceLoader, sourcePath: string, exportName: string) {
  return lazy(() => resolveThemedComponent(sourceImport, sourcePath, exportName))
}

/** Shell layouts kept out of route modules so theme overrides can replace them. */
export const AuthLayout = themedLazy(
  () => import('@/shared/components/AuthLayout'),
  'shared/components/AuthLayout.tsx',
  'AuthLayout',
)

export const OnboardingLayout = themedLazy(
  () => import('@/app/OnboardingLayout'),
  'app/OnboardingLayout.tsx',
  'OnboardingLayout',
)

export const PropertyOutletLayout = themedLazy(
  () => import('@/features/reservation/layouts/PropertyOutletLayout'),
  'features/reservation/layouts/PropertyOutletLayout.tsx',
  'PropertyOutletLayout',
)

export const RootLanding = themedLazy(() => import('@/app/RootLanding'), 'app/RootLanding.tsx', 'RootLanding')

export const LegalPageView = themedLazy(
  () => import('@/features/legal/pages/LegalPageView'),
  'features/legal/pages/LegalPageView.tsx',
  'LegalPageView',
)

export const PropertiesListPage = themedLazy(
  () => import('@/features/reservation/pages/PropertiesListPage'),
  'features/reservation/pages/PropertiesListPage.tsx',
  'PropertiesListPage',
)

export const FavoritesPage = themedLazy(
  () => import('@/features/reservation/pages/FavoritesPage'),
  'features/reservation/pages/FavoritesPage.tsx',
  'FavoritesPage',
)

export const PropertyDetailPage = themedLazy(
  () => import('@/features/reservation/pages/PropertyDetailPage'),
  'features/reservation/pages/PropertyDetailPage.tsx',
  'PropertyDetailPage',
)

export const ReservationWizardPage = themedLazy(
  () => import('@/features/reservation/pages/ReservationWizardPage'),
  'features/reservation/pages/ReservationWizardPage.tsx',
  'ReservationWizardPage',
)

export const MyReservationsListPage = themedLazy(
  () => import('@/features/reservation/pages/MyReservationsListPage'),
  'features/reservation/pages/MyReservationsListPage.tsx',
  'MyReservationsListPage',
)

export const MyReservationDetailPage = themedLazy(
  () => import('@/features/reservation/pages/MyReservationDetailPage'),
  'features/reservation/pages/MyReservationDetailPage.tsx',
  'MyReservationDetailPage',
)

export const MyInvoicesPage = themedLazy(
  () => import('@/features/billing/pages/MyInvoicesPage'),
  'features/billing/pages/MyInvoicesPage.tsx',
  'MyInvoicesPage',
)

export const InvoiceDetailPage = themedLazy(
  () => import('@/features/billing/pages/InvoiceDetailPage'),
  'features/billing/pages/InvoiceDetailPage.tsx',
  'InvoiceDetailPage',
)

export const WaitingQueuePage = themedLazy(
  () => import('@/features/reservation/pages/WaitingQueuePage'),
  'features/reservation/pages/WaitingQueuePage.tsx',
  'WaitingQueuePage',
)

export const HighSeasonPeriodsPage = themedLazy(
  () => import('@/features/reservation/pages/HighSeasonPeriodsPage'),
  'features/reservation/pages/HighSeasonPeriodsPage.tsx',
  'HighSeasonPeriodsPage',
)

export const HighSeasonPropertiesPage = themedLazy(
  () => import('@/features/reservation/pages/HighSeasonPropertiesPage'),
  'features/reservation/pages/HighSeasonPropertiesPage.tsx',
  'HighSeasonPropertiesPage',
)

export const HighSeasonWeeksPage = themedLazy(
  () => import('@/features/reservation/pages/HighSeasonWeeksPage'),
  'features/reservation/pages/HighSeasonWeeksPage.tsx',
  'HighSeasonWeeksPage',
)

export const HighSeasonWishPage = themedLazy(
  () => import('@/features/reservation/pages/HighSeasonWishPage'),
  'features/reservation/pages/HighSeasonWishPage.tsx',
  'HighSeasonWishPage',
)

export const HighSeasonWishesTrackingPage = themedLazy(
  () => import('@/features/reservation/pages/HighSeasonWishesTrackingPage'),
  'features/reservation/pages/HighSeasonWishesTrackingPage.tsx',
  'HighSeasonWishesTrackingPage',
)

export const DropRoomPage = themedLazy(
  () => import('@/features/reservation/pages/DropRoomPage'),
  'features/reservation/pages/DropRoomPage.tsx',
  'DropRoomPage',
)

export const ReservationConfirmationPage = themedLazy(
  () => import('@/features/reservation/pages/ReservationConfirmationPage'),
  'features/reservation/pages/ReservationConfirmationPage.tsx',
  'ReservationConfirmationPage',
)

export const ReservationHubPage = themedLazy(
  () => import('@/features/reservation/pages/ReservationHubPage'),
  'features/reservation/pages/ReservationHubPage.tsx',
  'ReservationHubPage',
)

export const TicketingOffersPage = themedLazy(
  () => import('@/features/ticketing/pages/TicketingOffersPage'),
  'features/ticketing/pages/TicketingOffersPage.tsx',
  'TicketingOffersPage',
)

export const TicketingOfferDetailPage = themedLazy(
  () => import('@/features/ticketing/pages/TicketingOfferDetailPage'),
  'features/ticketing/pages/TicketingOfferDetailPage.tsx',
  'TicketingOfferDetailPage',
)

export const ListingCatalogPage = themedLazy(
  () => import('@/features/listing/pages/ListingCatalogPage'),
  'features/listing/pages/ListingCatalogPage.tsx',
  'ListingCatalogPage',
)

export const ListingDetailPage = themedLazy(
  () => import('@/features/listing/pages/ListingDetailPage'),
  'features/listing/pages/ListingDetailPage.tsx',
  'ListingDetailPage',
)

export const MyListingsPage = themedLazy(
  () => import('@/features/listing/pages/MyListingsPage'),
  'features/listing/pages/MyListingsPage.tsx',
  'MyListingsPage',
)

export const ListingEditPage = themedLazy(
  () => import('@/features/listing/pages/ListingEditPage'),
  'features/listing/pages/ListingEditPage.tsx',
  'ListingEditPage',
)

export const BlogCataloguePage = themedLazy(
  () => import('@/features/blog/pages/BlogCataloguePage'),
  'features/blog/pages/BlogCataloguePage.tsx',
  'BlogCataloguePage',
)

export const BlogDetailPage = themedLazy(
  () => import('@/features/blog/pages/BlogDetailPage'),
  'features/blog/pages/BlogDetailPage.tsx',
  'BlogDetailPage',
)

export const GroupTripCatalogPage = themedLazy(
  () => import('@/features/group-trip/pages/GroupTripCatalogPage'),
  'features/group-trip/pages/GroupTripCatalogPage.tsx',
  'GroupTripCatalogPage',
)

export const GroupTripDetailPage = themedLazy(
  () => import('@/features/group-trip/pages/GroupTripDetailPage'),
  'features/group-trip/pages/GroupTripDetailPage.tsx',
  'GroupTripDetailPage',
)

export const MyGroupTripRegistrationsPage = themedLazy(
  () => import('@/features/group-trip/pages/MyGroupTripRegistrationsPage'),
  'features/group-trip/pages/MyGroupTripRegistrationsPage.tsx',
  'MyGroupTripRegistrationsPage',
)

export const ColonySessionsPage = themedLazy(
  () => import('@/features/colony/pages/ColonySessionsPage'),
  'features/colony/pages/ColonySessionsPage.tsx',
  'ColonySessionsPage',
)

export const ColonySessionDetailPage = themedLazy(
  () => import('@/features/colony/pages/ColonySessionDetailPage'),
  'features/colony/pages/ColonySessionDetailPage.tsx',
  'ColonySessionDetailPage',
)

export const MyColonyRegistrationsPage = themedLazy(
  () => import('@/features/colony/pages/MyColonyRegistrationsPage'),
  'features/colony/pages/MyColonyRegistrationsPage.tsx',
  'MyColonyRegistrationsPage',
)

export const MatchCalendarPage = themedLazy(
  () => import('@/features/match-event/pages/MatchCalendarPage'),
  'features/match-event/pages/MatchCalendarPage.tsx',
  'MatchCalendarPage',
)

export const MatchDetailPage = themedLazy(
  () => import('@/features/match-event/pages/MatchDetailPage'),
  'features/match-event/pages/MatchDetailPage.tsx',
  'MatchDetailPage',
)

export const MatchClubCataloguePage = themedLazy(
  () => import('@/features/match-event/pages/MatchClubCataloguePage'),
  'features/match-event/pages/MatchClubCataloguePage.tsx',
  'MatchClubCataloguePage',
)

export const MyMatchPurchasesListPage = themedLazy(
  () => import('@/features/match-event/pages/MyMatchPurchasesListPage'),
  'features/match-event/pages/MyMatchPurchasesListPage.tsx',
  'MyMatchPurchasesListPage',
)

export const MyMatchPurchaseDetailPage = themedLazy(
  () => import('@/features/match-event/pages/MyMatchPurchaseDetailPage'),
  'features/match-event/pages/MyMatchPurchaseDetailPage.tsx',
  'MyMatchPurchaseDetailPage',
)

export const PartnerOfferCatalogPage = themedLazy(
  () => import('@/features/partner-offer/pages/PartnerOfferCatalogPage'),
  'features/partner-offer/pages/PartnerOfferCatalogPage.tsx',
  'PartnerOfferCatalogPage',
)

export const PartnerOfferDetailPage = themedLazy(
  () => import('@/features/partner-offer/pages/PartnerOfferDetailPage'),
  'features/partner-offer/pages/PartnerOfferDetailPage.tsx',
  'PartnerOfferDetailPage',
)

export const MyPartnerOfferClaimsPage = themedLazy(
  () => import('@/features/partner-offer/pages/MyPartnerOfferClaimsPage'),
  'features/partner-offer/pages/MyPartnerOfferClaimsPage.tsx',
  'MyPartnerOfferClaimsPage',
)

export const PartnerOfferRedeemPage = themedLazy(
  () => import('@/features/partner-offer/pages/PartnerOfferRedeemPage'),
  'features/partner-offer/pages/PartnerOfferRedeemPage.tsx',
  'PartnerOfferRedeemPage',
)

export const MyTicketsListPage = themedLazy(
  () => import('@/features/ticketing/pages/MyTicketsListPage'),
  'features/ticketing/pages/MyTicketsListPage.tsx',
  'MyTicketsListPage',
)

export const MyTicketDetailPage = themedLazy(
  () => import('@/features/ticketing/pages/MyTicketDetailPage'),
  'features/ticketing/pages/MyTicketDetailPage.tsx',
  'MyTicketDetailPage',
)

export const LotteryDrawsPage = themedLazy(
  () => import('@/features/lottery/pages/LotteryDrawsPage'),
  'features/lottery/pages/LotteryDrawsPage.tsx',
  'LotteryDrawsPage',
)

export const TombolaDrawsPage = themedLazy(
  () => import('@/features/lottery/pages/TombolaDrawsPage'),
  'features/lottery/pages/TombolaDrawsPage.tsx',
  'TombolaDrawsPage',
)

export const LotteryDrawDetailPage = themedLazy(
  () => import('@/features/lottery/pages/LotteryDrawDetailPage'),
  'features/lottery/pages/LotteryDrawDetailPage.tsx',
  'LotteryDrawDetailPage',
)

export const NotificationsCenterPage = themedLazy(
  () => import('@/features/notifications/pages/NotificationsCenterPage'),
  'features/notifications/pages/NotificationsCenterPage.tsx',
  'NotificationsCenterPage',
)

export const CartPage = themedLazy(() => import('@/features/cart/pages/CartPage'), 'features/cart/pages/CartPage.tsx', 'CartPage')

export const AuthLoginPage = themedLazy(
  () => import('@/features/auth/pages/AuthLoginPage'),
  'features/auth/pages/AuthLoginPage.tsx',
  'AuthLoginPage',
)

export const AuthForgotPasswordPage = themedLazy(
  () => import('@/features/auth/pages/AuthForgotPasswordPage'),
  'features/auth/pages/AuthForgotPasswordPage.tsx',
  'AuthForgotPasswordPage',
)

export const AuthResetPasswordPage = themedLazy(
  () => import('@/features/auth/pages/AuthResetPasswordPage'),
  'features/auth/pages/AuthResetPasswordPage.tsx',
  'AuthResetPasswordPage',
)

export const AuthSignupPage = themedLazy(
  () => import('@/features/auth/pages/AuthSignupPage'),
  'features/auth/pages/AuthSignupPage.tsx',
  'AuthSignupPage',
)

export const AuthInvitationAcceptPage = themedLazy(
  () => import('@/features/auth/pages/AuthInvitationAcceptPage'),
  'features/auth/pages/AuthInvitationAcceptPage.tsx',
  'AuthInvitationAcceptPage',
)

export const AuthRegisterConfirmPage = themedLazy(
  () => import('@/features/auth/pages/AuthRegisterConfirmPage'),
  'features/auth/pages/AuthRegisterConfirmPage.tsx',
  'AuthRegisterConfirmPage',
)

export const AuthMagicLinkPage = themedLazy(
  () => import('@/features/auth/pages/AuthMagicLinkPage'),
  'features/auth/pages/AuthMagicLinkPage.tsx',
  'AuthMagicLinkPage',
)

export const AuthImpersonatePage = themedLazy(
  () => import('@/features/auth/pages/AuthImpersonatePage'),
  'features/auth/pages/AuthImpersonatePage.tsx',
  'AuthImpersonatePage',
)

export const MeLayout = themedLazy(() => import('@/app/MeLayout'), 'app/MeLayout.tsx', 'MeLayout')

export const ProfilePage = themedLazy(
  () => import('@/features/profile/pages/ProfilePage'),
  'features/profile/pages/ProfilePage.tsx',
  'ProfilePage',
)

export const BeneficiariesPage = themedLazy(
  () => import('@/features/profile/pages/BeneficiariesPage'),
  'features/profile/pages/BeneficiariesPage.tsx',
  'BeneficiariesPage',
)

export const SessionsPage = themedLazy(
  () => import('@/features/profile/pages/SessionsPage'),
  'features/profile/pages/SessionsPage.tsx',
  'SessionsPage',
)

export const GdprRequestsPage = themedLazy(
  () => import('@/features/profile/pages/GdprRequestsPage'),
  'features/profile/pages/GdprRequestsPage.tsx',
  'GdprRequestsPage',
)

export const OnboardingPage = themedLazy(
  () => import('@/features/onboarding/pages/OnboardingPage'),
  'features/onboarding/pages/OnboardingPage.tsx',
  'OnboardingPage',
)

export const FaqPage = themedLazy(() => import('@/features/faq/pages/FaqPage'), 'features/faq/pages/FaqPage.tsx', 'FaqPage')

export const PartnerScannerPage = themedLazy(
  () => import('@/features/partner/pages/PartnerScannerPage'),
  'features/partner/pages/PartnerScannerPage.tsx',
  'PartnerScannerPage',
)
